import styled, { css } from 'styled-components';
import { toRem } from '@marriott/mi-ui-library';
import { baseVariables } from '@marriott/mi-ui-library';
import { chatKeyboardFocusVisible } from '../../styles/chatFocus';

interface WrapperProps {
  expanded?: boolean;
  alignment?: 'bottom' | 'top';
}

export const Wrapper = styled.button<WrapperProps>`
  width: ${({ expanded }) => (expanded ? '100%' : 'auto')};
  min-width: 32px;
  background: none;
  border-radius: ${toRem(4)};
  border: none;
  cursor: pointer;
  font-size: 1.25rem;
  display: inline-flex;
  align-items: center;
  justify-content: ${({ expanded }) => (expanded ? 'flex-start' : 'center')};
  color: var(--t-brand-fg-color, #1c1c1c);
  gap: ${({ expanded }) => (expanded ? toRem(8) : 0)};
  font-family: ${baseVariables.font.fontFamilySwiss};
  transition: width 0.3s ease;
  height: ${toRem(32)};
  &:hover {
    background: ${({ expanded }) => (expanded ? 'none' : '#EEE')} !important;
  }

  ${chatKeyboardFocusVisible}

  ${({ alignment }) =>
    alignment === 'bottom' &&
    css`
      margin-top: auto;
    `}
`;

export const ButtonLabel = styled.div`
  white-space: nowrap;
  font-size: ${toRem(14)} !important;
  flex: 1;
  text-align: left;

  @media (max-width: 767px) {
    font-size: ${toRem(16)} !important;
  }
`;

export const RightIconWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
`;
